'use client';

import { LearningRailFrame } from './_LearningRailFrame';
import { LearningItemCard } from './_LearningItemCard';

export interface CampsAndCompetitionsProps {
  title?: string;
  subtitle?: string;
  source?: string;
  limit?: number;
  campsLabel?: string;
  competitionsLabel?: string;
  eventHrefTemplate?: string;
}

function clamp(n: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, n));
}

export function CampsAndCompetitions({
  title,
  subtitle,
  source: rawSource,
  limit: rawLimit,
  eventHrefTemplate = '/events/{id}',
}: CampsAndCompetitionsProps) {
  const source = (rawSource ?? '').trim() || 'camps_and_competitions';
  const limit = clamp(
    typeof rawLimit === 'number' && Number.isFinite(rawLimit) ? rawLimit : 8,
    2,
    16,
  );
  return (
    <LearningRailFrame
      blockType="CampsAndCompetitions"
      source={source}
      limit={limit}
      title={title}
      subtitle={subtitle}
      skeletonLayout="grid"
      emptyTitle="No camps or competitions"
      emptyHint="Programmes appear here when published."
    >
      {(items) => (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(min(260px, 100%), 1fr))',
            gap: 'clamp(12px, 2vw, 16px)',
          }}
        >
          {items.map((item) => (
            <LearningItemCard
              key={item.id}
              item={item}
              hrefTemplate={eventHrefTemplate}
              kind="event"
            />
          ))}
        </div>
      )}
    </LearningRailFrame>
  );
}
